const EMPLOYEE_EMAIL_DOMAIN = '@suitsupply.com'

export function isEmployeeEmail(email?: string | null): boolean {
  return !!email && email.toLowerCase().endsWith(EMPLOYEE_EMAIL_DOMAIN)
}
